class PlayerEvent {
	static get LOADING_COMPLETE(){
		return "player_loading_complete";
	}
}
export {PlayerEvent}